import { authHttp } from '../http'
import * as routes from '../../routes/patio.routes'
import { errorHandler } from '../../../util/error.service'
import { getUsuarioInfo } from '../../../localstorage/localstorage.service'

export async function getUtilizacoes({ tp_id, pInicial, pFinal }) {
  try {
    const { data } = await authHttp().get(routes.urlGetTomadaUtilizacoes, {
      params: { tp_id, pInicial, pFinal },
    })
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveUtilizacao(payload) {
  try {
    const { id: userId } = getUsuarioInfo()
    const { data } = await authHttp().post(routes.urlPostTomadaUtilizacao(userId), payload)
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function finalizarUtilizacao(id) {
  try {
    const { data } = await authHttp().patch(routes.urlPatchFinalizarTomadaUtilizacao(id))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}
